import { pl } from '../routes/pl';
import { en } from '../routes/en';

export const ROUTES = {
  pl,
  en,
};
